import React from 'react'

import { StCredits } from './style.css'

const Credits = () => (
  <StCredits>
    <div className="creditsWrapper">
      <h2>Créditos</h2>

      <p className="p-0 m-0 font-sans ">
        <span>Coordinación y edición:</span>
      </p>
      <p className="p-0 m-0 mb-4 font-sans ">
        <strong>Andrés Muñoz</strong>
        <strong>Tania Opazo</strong>
        <strong>Sebastián Rivas</strong>
      </p>
      <p className="p-0 m-0 font-sans ">
        <span>Periodistas:</span>
      </p>
      <p className="p-0 m-0 mb-4 font-sans ">
        <strong>Jorge Arellano</strong>
        <strong>Francisco Artaza</strong>
        <strong>Valentina Danker</strong>
        <strong>Cristóbal Fuentes</strong>
        <strong>Nicole Iporre</strong>
        <strong>Juan Manuel Ojeda</strong>
        <strong>Anita Moraga</strong>
        <strong>Catalina Quezada</strong>
        <strong>Carlos Said</strong>
        <strong>Danitza Soto</strong>
      </p>
      <p className="p-0 m-0 font-sans ">
        <span>Data Scientist:</span>
      </p>
      <p className="p-0 m-0 mb-4 font-sans ">
        <strong>Jorge Fábrega</strong>
      </p>
      <p className="p-0 m-0 font-sans ">
        <span>Diseño:</span>
      </p>
      <p className="p-0 m-0 mb-4 font-sans ">
        <strong>Alfredo Duarte</strong>
      </p>
      <p className="p-0 m-0 font-sans ">
        <span>Desarrollo:</span>
      </p>
      <p className="p-0 m-0 mb-4 font-sans ">
        <strong>Álex Acuña Viera</strong>
      </p>
      <p className="leading-none">
        <strong>
          Dedicado a nuestro compañero
          <br /> Francisco Aguirre.
        </strong>
      </p>
    </div>
  </StCredits>
)

export default Credits
